import * as React from 'react';
import { 
  DialogContent,
  IconButton,
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from '@mui/material';

import CloseIcon from '@mui/icons-material/Close';

import { useDispatch, useSelector } from 'react-redux';
import { CDialog, CDialogTitle, CDialogActions, CButton, CTextField } from '../components/common/Modal';

import { getTemplate } from '../slices/utils';

export default function PresentationModal(props) {
  const {open, defaultTitle, defaultModel, handleSave, handleClose} = props;  
  const templates = useSelector(state => state.utils.templates);

  const [title, setTitle] = React.useState(defaultTitle);
  const [model, setModel] = React.useState(defaultModel);

  const dispatch = useDispatch();

  React.useEffect(() => {
    setTitle(defaultTitle);
    setModel(defaultModel);
    if(templates.length === 0) {
      dispatch(getTemplate())
    }
  }, [defaultTitle, defaultModel, dispatch]);

  return (
    <>
      <CDialog
        open={open}
        onClose={handleClose}
        maxWidth={"xs"}
        fullWidth
      >
        <CDialogTitle>Presentation</CDialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 6,
            top: 6,
            color: (theme) => theme.palette.grey[800],
          }}
        >
          <CloseIcon fontSize='small' />
        </IconButton>
        <DialogContent>
        <CTextField
          required
          margin="dense"
          id="title"
          name="title"
          label="Title"
          type="text"
          size="small"
          fullWidth
          variant="outlined"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />
        <FormControl sx={{mt: 1}} size='small' fullWidth>
          <InputLabel id="presentation-model-selector">Template</InputLabel>
          <Select
            labelId="presentation-model-selector-label"
            id="presentation-model-selector"
            value={model}
            required
            label="Template"
            onChange={(e) => setModel(e.target.value)}
            fullWidth={true}
            >
              {
                templates.map(item=> (<MenuItem key={item} value={item}>{item}</MenuItem>))
              }
          </Select>
        </FormControl>
        </DialogContent>
        <CDialogActions>
          <CButton onClick={handleClose}>Cancel</CButton>
          <CButton onClick={() => handleSave(title, model)}>Ok</CButton>
        </CDialogActions>
      </CDialog>
    </>
  )
}